/**
* Chapter 6 Page
*
* Wrapper page for Chapter 6: The Sharing Tree
* Handles navigation back to contents and integration with the overall book flow
*/
import Chapter6Optimized from "@/components/chapters/chapter-6-optimized";
import { useNavigate } from "react-router-dom";

export default function Chapter6() {
  const navigate = useNavigate();

  const handleBackToContents = () => {
    navigate("/book/wtbtg");
  };

  return (
    <Chapter6Optimized onBackToContents={handleBackToContents} />
  );
}
